import { tokenManager } from '../lib/api-client';

type PermissionGroup =
  | 'users'
  | 'drivers'
  | 'documents'
  | 'trips'
  | 'payments'
  | 'support'
  | 'faq'
  | 'promo'
  | 'settings'
  | 'staff';

type PermissionAction = 'read' | 'create' | 'update' | 'delete' | 'block' | 'verify' | 'review' | 'reply' | 'resolve' | 'cancel';

/**
 * Check if current staff has a specific permission.
 * Super admins always have all permissions.
 */
export function hasPermission(group: PermissionGroup, action: PermissionAction): boolean {
  const user = tokenManager.getUser();
  if (!user) return false;

  // Super admins bypass all checks
  if (user.isSuperAdmin) return true;

  const permissions = user.permissions as Record<string, string[]> | null;
  if (!permissions) return false;

  const groupPerms = permissions[group];
  if (!groupPerms) return false;

  return groupPerms.includes(action);
}

/**
 * React hook to check permissions. Returns a checker function.
 */
export function usePermission() {
  return {
    can: hasPermission,
    isSuperAdmin: () => {
      const user = tokenManager.getUser();
      return user?.isSuperAdmin === true;
    },
  };
}
